import { module } from 'modujs';
import { lerp } from '../utils/maths';
import gsap from 'gsap';
import { ENV } from "../config";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        if (ENV.IS_TOUCH) return;
        
        this.elts = [];
        this.update();
        
        this.cursorTxt = this.el.querySelector('.c-cursor_txt');

        this.data = {
            mouse: { x: 0, y: 0 },
            current: { x: 0, y: 0 },
            last: { x: 0, y: 0 },
            ease: 0.15,
            velo: 3,
            // fx: { diff: 0, acc: 0, velo: 0, scale: 0 }
            fxX: { diff: 0, acc: 0, velo: 0, scale: 0 },
            fxY: { diff: 0, acc: 0, velo: 0, scale: 0 }
        };

        this.rAF = null;
        this.targets = null;

        this.run = this.run.bind(this);
        this.mousePos = this.mousePos.bind(this);
        this.documentEnter = this.documentEnter.bind(this);
        this.documentLeave = this.documentLeave.bind(this);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);

        this.raf();
    }

    update() {
        if (ENV.IS_TOUCH) return;
        
        this.elts = [...document.querySelectorAll('a'), ...document.querySelectorAll('button'), ...document.querySelectorAll('div[data-cursor-txt]'), ...document.querySelectorAll('span[data-cursor-txt]')];
        this.addListeners();
    }

    mousePos(e) {
        this.el.classList.remove('-hidden');

        this.data.mouse.x = e.clientX;
        this.data.mouse.y = e.clientY;

        this.data.current.x = e.clientX;
        this.data.current.y = e.clientY;
    }

    run() {
        this.data.last.x = lerp(this.data.last.x, this.data.current.x, this.data.ease);
        this.data.last.y = lerp(this.data.last.y, this.data.current.y, this.data.ease);

        // X & Y scales are the same
        // this.data.fx.diff = (this.data.current.x - this.data.last.x) - (this.data.current.y - this.data.last.y);
        // this.data.fx.acc = this.data.fx.diff / window.innerWidth;
        // this.data.fx.velo = + this.data.fx.acc;
        // this.data.fx.scale = 1 - Math.abs(this.data.fx.velo * this.data.velo);
        // this.el.style.transform = `translate3d(${this.data.last.x}px, ${this.data.last.y}px, 0) scale(${this.data.fx.scale})`;

        // X & Y scales are differents
        this.data.fxX.diff = (this.data.current.x - this.data.last.x);
        this.data.fxX.acc = this.data.fxX.diff / window.innerWidth;
        this.data.fxX.velo = + this.data.fxX.acc;
        this.data.fxX.scale = 1 - Math.abs(this.data.fxX.velo * this.data.velo);

        this.data.fxY.diff = (this.data.current.y - this.data.last.y);
        this.data.fxY.acc = this.data.fxY.diff / window.innerHeight;
        this.data.fxY.velo = + this.data.fxY.acc;
        this.data.fxY.scale = 1 - Math.abs(this.data.fxY.velo * this.data.velo);

        this.el.style.transform = `translate3d(${this.data.last.x}px, ${this.data.last.y}px, 0) scale(${this.data.fxY.scale}, ${this.data.fxX.scale})`;

        this.raf();
    }

    raf() {
        this.rAF = requestAnimationFrame(this.run);
    }

    documentEnter() {
        this.el.classList.remove('-hidden');
    }

    documentLeave() {
        this.el.classList.add('-hidden');
    }

    mouseEnter(e) { 
        if (e.target.hasAttribute('data-cursor-txt')) {
            let txt = e.target.getAttribute('data-cursor-txt');
            this.el.classList.add('-active');
            if (e.target.hasAttribute('data-cursor-move')) {
                this.el.classList.add('-move');
            }
            this.el.classList.remove('-disabled');
            let span = document.createElement('span');
            var res = txt.split('').map(function(el, i) {
                return `<span class="char" style="--c-index: ${i}">${ el == ' ' ? '&nbsp;' : el }</span>`;
            }).join('');
            span.innerHTML = res;

            this.cursorTxt.appendChild(span);
            this.showContent(span);
        } else {
            this.el.classList.add('-disabled');
        }
    }

    mouseLeave() {
        this.hideContent();
        this.el.classList.remove('-active');
        this.el.classList.remove('-disabled');
        this.el.classList.remove('-move');
    }

    showContent(span){
        gsap.fromTo(
            span.querySelectorAll('.char'),
            {
                opacity: 0,
                scale: 0.2,
                x: -10,
            },
            {
                opacity: 1,
                scale: 1,
                x: 0,
                duration: 0.6,
                stagger: {
                    each: 0.05,
                    from: 'start'
                },
                ease: 'elastic.out(1,0.45)'
            }
        );
    }

    hideContent(){
        if (this.cursorTxt.querySelectorAll('span').length > 0){
            this.cursorTxt.querySelectorAll('span').forEach(element => {
                if (element.querySelectorAll('.char').length) {
                    element.querySelectorAll('.char').forEach(char => {
                        gsap.killTweensOf(char);
                    });

                    gsap.to(element.querySelectorAll('.char'), {
                        opacity: 0,
                        duration: 0.2,
                        // stagger: 0.03,
                        ease: 'power4.out',
                        onComplete: () => {
                            element.remove();
                        }
                    });
                }
            });
        }
    }

    addListeners() {
        window.addEventListener('mousemove', (e) => { this.mousePos(e) }, { passive: true });
        document.addEventListener('mouseenter', (e) => { this.documentEnter(e); }, { passive: true });
        document.addEventListener('mouseleave', (e) => { this.documentLeave(e); }, { passive: true });

        if (this.elts){
            this.elts.forEach((elt) => {
                elt.addEventListener('mouseenter', (e) => { this.mouseEnter(e); }, { passive: true });
                elt.addEventListener('mouseleave', (e) => { this.mouseLeave(e); }, { passive: true });
            });
        }
    }
}
